// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { N40 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var UpperAvatarThread = styled.div({
  marginLeft: "var(--ds-space-250, 20px)",
  borderLeft: "2px solid ".concat("var(--ds-border, ".concat(N40, ")")),
  height: '16px',
  marginTop: "var(--ds-space-negative-200, -16px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var LowerAvatarThread = styled.div({
  marginLeft: "var(--ds-space-250, 20px)",
  borderLeft: "2px solid ".concat("var(--ds-border, ".concat(N40, ")")),
  height: "calc(100% - ".concat("var(--ds-space-400, 32px)", ")")
});